/* Maison Embra — small behaviours for embra-* sections and blocks */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  /* Countdown: data-mode="midnight" resets every day at local midnight, "date" counts to data-end */
  function initCountdowns(root = document) {
    root.querySelectorAll('[data-em-countdown]:not([data-em-ready])').forEach((el) => {
      el.dataset.emReady = '1';
      const mode = el.dataset.mode || 'midnight';
      const end = el.dataset.end ? new Date(el.dataset.end.replace(' ', 'T')) : null;
      const h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      const tick = () => {
        const now = new Date();
        let target;
        if (mode === 'date' && end && !isNaN(end)) target = end;
        else { target = new Date(now); target.setHours(24, 0, 0, 0); }
        let diff = Math.max(0, Math.floor((target - now) / 1000));
        const hh = Math.floor(diff / 3600); diff -= hh * 3600;
        const mm = Math.floor(diff / 60); const ss = diff - mm * 60;
        if (h) h.textContent = pad(hh); if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
      };
      tick(); setInterval(tick, 1000);
    });
  }

  /* Rotating messages (top bar) */
  function initRotators(root = document) {
    root.querySelectorAll('[data-em-rotate]:not([data-em-ready])').forEach((el) => {
      el.dataset.emReady = '1';
      const items = [...el.querySelectorAll('.em-topbar__msg')];
      if (items.length < 2) { items[0]?.classList.add('is-on'); return; }
      let i = 0; items[0].classList.add('is-on');
      const ms = (parseInt(el.dataset.emRotate, 10) || 4) * 1000;
      setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, ms);
    });
  }

  /* Slider (features) */
  function initSliders(root = document) {
    root.querySelectorAll('[data-em-slider]:not([data-em-ready])').forEach((el) => {
      el.dataset.emReady = '1';
      const slides = [...el.querySelectorAll('.em-slide')];
      const dots = [...el.querySelectorAll('.em-slider__dots button')];
      if (!slides.length) return;
      let i = 0, timer;
      const go = (n) => {
        slides[i].classList.remove('is-on'); dots[i]?.classList.remove('is-on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on'); dots[i]?.classList.add('is-on');
      };
      const auto = parseInt(el.dataset.emSlider, 10) || 0;
      const restart = () => { clearInterval(timer); if (auto > 0 && slides.length > 1) timer = setInterval(() => go(i + 1), auto * 1000); };
      el.querySelector('.em-slider__nav--p')?.addEventListener('click', () => { go(i - 1); restart(); });
      el.querySelector('.em-slider__nav--n')?.addEventListener('click', () => { go(i + 1); restart(); });
      dots.forEach((d, n) => d.addEventListener('click', () => { go(n); restart(); }));
      let x0 = null;
      el.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); } x0 = null; });
      el.addEventListener('shopify:block:select', (e) => { const n = slides.findIndex((s) => s.contains(e.target) || s === e.target); if (n > -1) { go(n); clearInterval(timer); } });
      restart();
    });
  }

  /* Collection sort */
  function initSort(root = document) {
    root.querySelectorAll('[data-em-sort]:not([data-em-ready])').forEach((sel) => {
      sel.dataset.emReady = '1';
      sel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
  }

  /* Variant notes: adds a small line + badge under each size button of the Horizon variant picker */
  const norm = (t) => String(t || '').toLowerCase().replace(/["”″'’\s]|inches|inch|in\b/g, '');
  function applyAtcPrice(section) {
    const btn = section.querySelector('.product-information button[name="add"], button[name="add"].add-to-cart-button');
    const price = section.querySelector('.em-pb-price__now');
    if (!btn || !price || btn.disabled) { btn?.querySelector('.em-atc-price')?.remove(); return; }
    let el = btn.querySelector('.em-atc-price');
    const txt = '· ' + price.textContent.trim();
    if (!el) { el = document.createElement('span'); el.className = 'em-atc-price'; const added = btn.querySelector('.add-to-cart__added'); added ? btn.insertBefore(el, added) : btn.appendChild(el); }
    if (el.textContent !== txt) el.textContent = txt;
  }
  function applyVariantNotes(section) {
    applyAtcPrice(section);
    const src = section.querySelector('[data-em-variant-notes]');
    if (!src) return;
    let notes; try { notes = JSON.parse(src.textContent); } catch (e) { return; }
    if (!notes.length) return;
    section.querySelectorAll('.variant-option--buttons').forEach((fs) => {
      const inputs = [...fs.querySelectorAll('.variant-option__button-label input')];
      if (!inputs.some((i) => notes.find((x) => norm(x.v) === norm(i.value)))) return;
      fs.classList.add('em-sizes');
      fs.querySelectorAll('.variant-option__button-label').forEach((label) => {
        const input = label.querySelector('input');
        const n = input && notes.find((x) => norm(x.v) === norm(input.value));
        if (n && n.b && !label.querySelector('.em-vbadge')) { const b = document.createElement('span'); b.className = 'em-vbadge'; b.textContent = n.b; label.prepend(b); }
      });
      if (fs.nextElementSibling && fs.nextElementSibling.classList.contains('em-vfit')) fs.nextElementSibling.remove();
    });
  }

  /* Live blocks: re-render embra blocks when the variant changes */
  const bound = new WeakSet();
  function bindSection(section) {
    if (bound.has(section)) return;
    bound.add(section);
    section.addEventListener('shopify:product:select', (event) => {
      const p = event.promise;
      if (!p || typeof p.then !== 'function') return;
      p.then((res) => {
        const html = res && res.detail && res.detail.html;
        if (!html) return;
        section.querySelectorAll('[data-em-live]').forEach((el) => {
          const fresh = html.querySelector(`[data-em-live="${el.dataset.emLive}"]`);
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
        requestAnimationFrame(() => applyVariantNotes(section));
      }).catch(() => {});
    });
    if (section.querySelector('[data-em-variant-notes], .em-pb-price')) {
      applyVariantNotes(section);
      let queued = false;
      new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; applyVariantNotes(section); }); })
        .observe(section, { childList: true, subtree: true });
    }
  }
  function initProduct(root = document) {
    root.querySelectorAll('[data-em-live], [data-em-variant-notes]').forEach((el) => {
      const s = el.closest('.shopify-section');
      if (s) bindSection(s);
    });
  }


  /* Videos: lazy, muted autoplay; data-desktop ones never load on phones */
  function initVideos(root = document) {
    const vids = [...root.querySelectorAll('video[data-em-video]:not([data-em-ready])')];
    if (!vids.length) return;
    const desk = window.matchMedia('(min-width: 750px)').matches;
    const start = (v) => {
      /* start right after first paint (not after full page load, which is slow on phones) */
      if (!window.__emLoaded) { (window.__emQ = window.__emQ || []).push(v); return; }
      emPlay(v);
    };
    const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target; if (e.isIntersecting) start(v); else if (v.src) v.pause();
    }), { rootMargin: '200px' }) : null;
    vids.forEach((v) => {
      v.dataset.emReady = '1';
      if (!v.dataset.src) return;
      if ((v.hasAttribute('data-desktop') || v.closest('.em-desk-only')) && !desk) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      io ? io.observe(v) : start(v);
    });
  }

  function emPlay(v) {
    if (!v.src) { v.muted = true; v.defaultMuted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('autoplay', ''); v.src = v.dataset.src; }
    if (!v.dataset.emBound) { v.dataset.emBound = '1'; v.addEventListener('playing', () => v.classList.add('is-playing')); }
    const p = v.play(); if (p && p.catch) p.catch(() => { v.dataset.emBlocked = '1'; });
  }
  const emRelease = () => {
    if (window.__emLoaded) return;
    window.__emLoaded = true;
    (window.__emQ || []).splice(0).forEach(emPlay);
  };
  if (document.readyState === 'complete') setTimeout(emRelease, 300);
  else { window.addEventListener('DOMContentLoaded', () => setTimeout(emRelease, 600)); window.addEventListener('load', emRelease); }
  /* iPhone Low Power Mode and data saver block autoplay: retry on the visitor's first tap or scroll */
  const emRetry = () => {
    document.querySelectorAll('video[data-em-video]').forEach((v) => {
      const r = v.getBoundingClientRect();
      if (r.bottom > -200 && r.top < window.innerHeight + 200 && (v.paused || v.dataset.emBlocked)) { delete v.dataset.emBlocked; emPlay(v); }
    });
  };
  ['touchstart', 'pointerdown', 'keydown'].forEach((ev) => window.addEventListener(ev, emRetry, { passive: true }));
  let emScrollT; window.addEventListener('scroll', () => { clearTimeout(emScrollT); emScrollT = setTimeout(emRetry, 150); }, { passive: true });

  /* Images: start loading lazy images well before they scroll into view (Safari waits until the last moment) */
  function initImageLookahead(root = document) {
    const imgs = [...root.querySelectorAll('img[loading="lazy"]:not([data-em-la])')];
    if (!imgs.length || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.loading = 'eager'; io.unobserve(e.target); }
    }), { rootMargin: '1500px 600px' });
    imgs.forEach((i) => { i.dataset.emLa = '1'; io.observe(i); });
  }

  /* Cart: show one full-width express-checkout button (the best wallet for the device), like the product page */
  function fitWallets() {
    document.querySelectorAll('shopify-accelerated-checkout-cart').forEach((c) => {
      const p = c.parentElement; if (!p) return;
      p.classList.add('em-wallet-one');
      const ks = [...c.children];
      if (ks.length < 2) { c.style.width = ''; return; }
      const W = p.getBoundingClientRect().width; if (!W) return;
      const a = ks[0].getBoundingClientRect(), b = ks[1].getBoundingClientRect();
      let gap = b.left - a.right; if (!(gap >= 0 && gap < 40)) gap = 10;
      c.style.width = (ks.length * W + (ks.length - 1) * gap) + 'px';
    });
  }
  let emFitT; const emFitSoon = () => { cancelAnimationFrame(emFitT); emFitT = requestAnimationFrame(fitWallets); };
  const emRO = 'ResizeObserver' in window ? new ResizeObserver(emFitSoon) : null;
  new MutationObserver((ms) => {
    let hit = false;
    for (const m of ms) for (const n of m.addedNodes) if (n.nodeType === 1 && (n.matches?.('shopify-accelerated-checkout-cart, shopify-accelerated-checkout-cart *') || n.querySelector?.('shopify-accelerated-checkout-cart'))) hit = true;
    if (hit) emWatchWallets();
  }).observe(document.documentElement, { childList: true, subtree: true });
  function emWatchWallets() {
    document.querySelectorAll('shopify-accelerated-checkout-cart').forEach((c) => { if (emRO && c.parentElement && !c.parentElement.dataset.emRo) { c.parentElement.dataset.emRo = '1'; emRO.observe(c.parentElement); } });
    emFitSoon();
  }
  window.addEventListener('resize', emFitSoon);

  /* Tabs (help FAQ) */
  function initTabs(root = document) {
    root.querySelectorAll('[data-em-tabs]:not([data-em-ready])').forEach((el) => {
      el.dataset.emReady = '1';
      const tabs = [...el.querySelectorAll('.em-tab')], panels = [...el.querySelectorAll('.em-tabs__panel')];
      const go = (i) => { tabs.forEach((t, n) => t.classList.toggle('is-on', n === i)); panels.forEach((p, n) => p.classList.toggle('is-on', n === i)); };
      tabs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      el.addEventListener('shopify:block:select', (e) => { const t = tabs.indexOf(e.target); if (t > -1) go(t); const p = panels.findIndex((x) => x.contains(e.target)); if (p > -1) go(p); });
      if (location.hash) { const target = el.querySelector(location.hash.replace(/[^#\w-]/g, '')); const p = target ? panels.findIndex((x) => x.contains(target)) : -1; if (p > -1) go(p); }
    });
  }

  /* Email popup: once per N days, never after sign-up */
  function initPopup(root = document) {
    const el = root.querySelector('[data-em-popup]:not([data-em-ready])');
    if (!el) return;
    el.dataset.emReady = '1';
    const KEY = 'em_popup_until';
    const get = () => { try { return Number(localStorage.getItem(KEY) || 0); } catch (e) { return 0; } };
    const set = (days) => { try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {} };
    const open = () => { el.hidden = false; document.documentElement.style.overflow = 'hidden'; };
    const close = () => { el.hidden = true; document.documentElement.style.overflow = ''; set(Number(el.dataset.days) || 14); };
    el.querySelectorAll('[data-em-close]').forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !el.hidden) close(); });
    el.querySelector('form')?.addEventListener('submit', () => set(3650));
    if (el.querySelector('[data-em-popup-success]')) { open(); set(3650); return; }
    if (el.hasAttribute('data-editor')) { open(); return; }
    if (window.Shopify && Shopify.designMode) return;
    if (get() > Date.now()) return;
    setTimeout(open, (Number(el.dataset.delay) || 0) * 1000);
  }

  const initAll = (root) => { emWatchWallets(); initVideos(root); initImageLookahead(root); initTabs(root); initPopup(root); initCountdowns(root); initRotators(root); initSliders(root); initSort(root); initProduct(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
